// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageIcon-root-da2284f1f5c1e6e3d04f244487c9d80d"};